// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1lxrq","actions":"GroupTable_actions__3SQ9B","deleteModalFooter":"GroupTable_deleteModalFooter__2j7id"};